import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";

const ConfirmModal = ({
  isOpen,
  onRequestClose,
  onConfirm,
  message,
  confirmDisabled,
  typedProjectName,
  setTypedProjectName,
  projectName,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onRequestClose} centered>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="modal-overlay bg-black opacity-50 fixed inset-0"></div>
        <div className="modal-content bg-white rounded-lg p-6 z-50">
          <ModalHeader toggle={onRequestClose}>Confirmation</ModalHeader>
          <ModalBody>
            {message}
            <p className="mt-3">
              Type the project name{" "}
              <strong className="font-semibold">({projectName})</strong> to
              confirm:
            </p>
            <Input
              type="text"
              value={typedProjectName}
              onChange={(e) => setTypedProjectName(e.target.value)}
              placeholder="Type the project name"
              className="mt-4 mb-4 h-10 outline-1 outline-[#9999ff] border border-gray-300 p-2 rounded-md"
            />
          </ModalBody>
          <ModalFooter>
            <Button className="bg-[#9999ff]" onClick={onRequestClose}>
              Cancel
            </Button>
            <Button
              className="bg-[#ff8080] ml-3"
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              Delete
            </Button>
          </ModalFooter>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
